import React, { createContext, useState } from 'react';

// Create Context
export const CsvDataContext = createContext();

// Provider Component
export const CsvDataProvider = ({ children }) => {
  const [dataStore, setDataStore] = useState({});

  // Function to dynamically store data under a given key
  const addCsvData = (key, data) => {
    setDataStore((prevState) => ({
      ...prevState,
      [key]: data,  // Store data with a dynamic key (e.g., "trainingSessions", "patients")
    }));
  };

  return (
    <CsvDataContext.Provider value={{ dataStore, addCsvData }}>
      {children}
    </CsvDataContext.Provider>
  );
};
